import { Box, Container, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { FC, ReactNode } from 'react';



interface PageTitleWrapperProps {
    children?: ReactNode;
}



const PageTitleWrapper: FC<PageTitleWrapperProps> = ({ children }) => {
    return (<Box
        sx={{
            background: '##ffffff80',
            marginBottom: '36px',
            boxShadow: 'rgba(34, 51, 84, 0.1) 0px 2px 4px -3px, rgba(34, 51, 84, 0.05) 0px 5px 12px -4px',
            padding: '36px',
            width: '100%',



        }}

    >


        <Container>
            <Grid container spacing={3} justifyContent={'space-between'} >
                <Grid item sx={{ width: '100%' }}>
                    {children}
                </Grid>
            </Grid>
        </Container>


    </Box >);
}
PageTitleWrapper.propTypes = {
    children: PropTypes.element
};

export default PageTitleWrapper;